import type { NavItem } from '../use-nav-items'
import type { TranslateFn } from './types'

export function buildLearnMenuItem(t: TranslateFn): NavItem {
  return {
    id: 'learn',
    name: t('navigation.learn.name'),
    link: '/classes/',
    subMenuItems: [
      {
        id: 'blog',
        name: t('navigation.learn.blog.guide.name'),
        primaryName: t('navigation.learn.blog.guide.ultimate_guides'),
        secondaryName: t('navigation.learn.blog.articles.name'),
        trending: {
          image:
            'https://www.creativefabrica.com/wp-content/uploads/2023/12/13/0474-Images-nav-menu-10_Artistry-section.png',
          imageLink: '/the-artistry/',
          imageText: t('navigation.learn.blog.image_title'),
        },
        subMenuItems: [
          {
            name: t('navigation.learn.blog.guide.font'),
            link: '/the-ultimate-font-guide/',
          },
          {
            name: t('navigation.learn.blog.guide.cricut'),
            link: '/the-ultimate-cricut-guide/',
          },
          {
            name: t('navigation.learn.blog.guide.silhouette'),
            link: '/the-ultimate-silhouette-guide/',
          },
          {
            name: t('navigation.learn.blog.guide.canvas_workspace'),
            link: '/the-ultimate-brother-canvas-workspace-guide/',
          },
          {
            name: t('navigation.learn.blog.guide.pod'),
            link: '/the-ultimate-pod-guide/',
          },
          {
            name: t('navigation.learn.blog.guide.graphic_design'),
            link: '/the-ultimate-graphic-design-guide-2/',
          },
          {
            name: t('navigation.learn.blog.guide.machine_embroidery'),
            link: '/the-ultimate-machine-embroidery-guide/',
          },
          {
            name: t('navigation.learn.blog.guide.ai_art'),
            link: '/the-ultimate-ai-guide/',
          },
          {
            name: t('navigation.learn.blog.guide.etsy'),
            link: '/the-ultimate-etsy-guide/',
          },
          {
            name: t('navigation.learn.blog.view_all'),
            link: '/the-artistry/',
            isFootOption: true,
          },
        ],
        secondarySubMenuItems: [
          {
            name: t('navigation.learn.blog.articles.art1'),
            wrapTitle: true,
            link: '/the-artistry/fonts-and-digital-designs/learn-how-to-pair-fonts-with-25-perfect-font-combinations/',
          },
          {
            name: t('navigation.learn.blog.articles.art2'),
            wrapTitle: true,
            link: '/the-artistry/fonts-and-digital-designs/exclusive-offer-5-svg-cut-file-templates-for-free/',
          },
          {
            name: t('navigation.learn.blog.articles.art3'),
            wrapTitle: true,
            link: '/the-artistry/fonts-and-digital-designs/exclusive-offer-10-graphic-sets-for-free/',
          },
          {
            name: t('navigation.learn.blog.articles.art4'),
            wrapTitle: true,
            link: '/the-artistry/cricut-design-space/tutorial-using-digital-papers-in-design-space/',
          },
          {
            name: t('navigation.learn.blog.articles.art5'),
            wrapTitle: true,
            link: '/the-artistry/sublimation/how-to-sublimate-on-cotton-shirts/',
          },
          {
            name: t('navigation.learn.blog.articles.art6'),
            wrapTitle: true,
            link: '/the-artistry/kdp/the-top-5-profitable-amazon-kdp-niches-for-low-content/',
          },
          {
            name: t('navigation.learn.blog.articles.art7'),
            wrapTitle: true,
            link: '/the-artistry/christmas/creating-custom-split-monogram-name-ornaments/',
          },
          {
            name: t('navigation.learn.blog.articles.art8'),
            wrapTitle: true,
            link: '/the-artistry/cricut-design-space/the-best-fonts-for-vinyl-cutting/',
          },
          {
            name: t('navigation.learn.blog.articles.art9'),
            wrapTitle: true,
            link: '/the-artistry/sublimation/how-to-bleach-shirts-design-with-sublimation/',
          },
          {
            name: t('navigation.learn.blog.articles.art10'),
            wrapTitle: true,
            link: '/the-artistry/kdp/how-to-make-money-publishing-low-content-books-on-amazon-kdp/',
          },
        ],
      },
      {
        id: 'video-classes',
        name: t('navigation.learn.video.name'),
        wrapItems: true,
        trending: {
          image:
            'https://www.creativefabrica.com/wp-content/uploads/2023/12/13/0474-Images-nav-menu-07_Teaching-materials-section.png',
          imageLink: '/classes/',
          imageText: t('navigation.learn.video.explore_all'),
        },
        subMenuItems: [
          {
            name: t('navigation.learn.video.cricut'),
            link: '/subscriptions/classes/cricut/',
          },
          {
            name: t('navigation.learn.video.graphic_design'),
            link: '/subscriptions/classes/graphic-design/',
          },
          {
            name: t('navigation.learn.video.illustrating'),
            link: '/subscriptions/classes/illustrating/',
          },
          {
            name: t('navigation.learn.video.printing_sublimation'),
            link: '/subscriptions/classes/printing-sublimation/',
          },
          {
            name: t('navigation.learn.video.organizing_planning'),
            link: '/subscriptions/classes/organizing-planning/',
          },
          {
            name: t('navigation.learn.video.etsy'),
            link: '/subscriptions/classes/etsy/',
          },
          {
            name: t('navigation.learn.video.paper_crafting'),
            link: '/subscriptions/classes/paper-crafting/',
          },
          {
            name: t('navigation.learn.video.business'),
            link: '/subscriptions/classes/craft-business/',
          },
          {
            name: t('navigation.learn.video.embroidery'),
            link: '/subscriptions/classes/embroidery-classes/',
          },
          {
            name: t('navigation.learn.video.seasonal'),
            link: '/subscriptions/classes/seasonal/',
          },
          {
            name: t('navigation.learn.video.resin'),
            link: '/subscriptions/classes/resin/',
          },
          {
            name: t('navigation.learn.video.sewing'),
            link: '/subscriptions/classes/sewing/',
          },
          {
            name: t('navigation.learn.video.crochet'),
            link: '/subscriptions/classes/crochet-classes/',
          },
          {
            name: t('navigation.learn.video.macrame'),
            link: '/subscriptions/classes/macrame/',
          },
          {
            name: t('navigation.learn.video.painting'),
            link: '/subscriptions/classes/painting/',
          },
          {
            name: t('navigation.learn.video.clays'),
            link: '/subscriptions/classes/clays/',
          },
          {
            name: t('navigation.learn.video.candles_soap'),
            link: '/subscriptions/classes/candles-and-soap/',
          },
          {
            name: t('navigation.learn.video.scrapbooking'),
            link: '/subscriptions/classes/scrapbooking/',
          },
          {
            name: t('navigation.learn.video.doll_making'),
            link: '/subscriptions/classes/doll-making/',
          },
          {
            name: t('navigation.learn.video.jewelry_making'),
            link: '/subscriptions/classes/jewelry-making/',
          },
          {
            name: t('navigation.learn.video.silhouette'),
            link: '/subscriptions/classes/silhouette/',
          },
          {
            name: t('navigation.learn.video.home_decor'),
            link: '/subscriptions/classes/home-decor/',
          },
          {
            name: t('navigation.learn.video.die_cutting'),
            link: '/subscriptions/classes/die-cutting/',
          },
          {
            name: t('navigation.learn.video.woodworking'),
            link: '/subscriptions/classes/woodworking/',
          },
          {
            name: t('navigation.learn.video.view_all'),
            link: '/classes/',
            isFootOption: true,
          },
        ],
      },
      {
        id: 'clubhouses',
        name: t('navigation.clubhouses.name'),
        link: '/clubhouse/',
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.clubhouses.cricut'),
            link: '/clubhouse/cricut/',
          },
          {
            name: t('navigation.clubhouses.paper_crafts'),
            link: '/clubhouse/paper-crafts/',
          },
          {
            name: t('navigation.clubhouses.rhinestones'),
            link: '/clubhouse/rhinestones/',
          },
          {
            name: t('navigation.clubhouses.siser'),
            link: '/clubhouse/siser/',
          },
          {
            name: t('navigation.clubhouses.xtool'),
            link: '/clubhouse/xtool/',
          },
          {
            name: t('navigation.clubhouses.print-on-demand'),
            link: '/clubhouse/print-on-demand/',
          },
          {
            name: t('navigation.clubhouses.christmas'),
            link: '/clubhouse/christmas/',
          },
          {
            name: t('navigation.clubhouses.weddings'),
            link: '/clubhouse/weddings/',
          },
          {
            name: t('navigation.clubhouses.halloween'),
            link: '/clubhouse/halloween/',
          },
          {
            name: t('navigation.clubhouses.selling_on_etsy'),
            link: '/clubhouse/selling-on-etsy/',
          },
          {
            name: t('navigation.clubhouses.kids_crafts'),
            link: '/clubhouse/kids-crafts/',
          },
          {
            name: t('navigation.clubhouses.knitting'),
            link: '/clubhouse/knitting/',
          },
          {
            name: t('navigation.clubhouses.browse_all'),
            link: '/clubhouse/',
            isFootOption: true,
          },
        ],
      },
      {
        id: 'craft-ideas',
        name: t('navigation.learn.craft_ideas.name'),
        wrapItems: true,
        subMenuItems: [
          {
            name: t('navigation.learn.craft_ideas.wedding'),
            link: '/ideas/wedding/',
          },
          {
            name: t('navigation.learn.craft_ideas.easter'),
            link: '/ideas/easter/',
          },
          {
            name: t('navigation.learn.craft_ideas.halloween'),
            link: '/ideas/halloween/',
          },
          {
            name: t('navigation.learn.craft_ideas.4th_of_july'),
            link: '/ideas/4th-of-july/',
          },
          {
            name: t('navigation.learn.craft_ideas.mothers_day'),
            link: '/ideas/mothers-day/',
          },
          {
            name: t('navigation.learn.craft_ideas.christmas'),
            link: '/ideas/christmas/',
          },
        ],
      },
    ],
  }
}
